/**
 * VYRO video autoplay-on-view.
 * Mark up: <video data-vyro-autoplay-on-view muted playsinline loop>...</video>
 * Plays when ≥30% visible, pauses when out of view, respects reduced-motion.
 */
(() => {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!(video instanceof HTMLVideoElement)) return;
        if (entry.isIntersecting && !REDUCED) {
          // preload="none": ask for the data only now, when the video is about to be seen
          if (video.preload === 'none') {
            video.preload = 'auto';
            video.load();
          }
          video.play().catch(() => {
            /* Autoplay blocked (low-power mode, data saver): the poster stays visible. */
            video.setAttribute('controls', '');
          });
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.25, rootMargin: '200px 0px' }  // start loading just before it enters the screen
  );

  const init = (root = document) => {
    root.querySelectorAll('video[data-vyro-autoplay-on-view]').forEach((v) => {
      // Ensure playback prerequisites for autoplay across browsers.
      v.muted = true;
      v.playsInline = true;
      observer.observe(v);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
